import { render, staticRenderFns } from "./Form_jtbttjb.vue?vue&type=template&id=55a907fa"
import script from "./Form_jtbttjb.vue?vue&type=script&lang=js"
export * from "./Form_jtbttjb.vue?vue&type=script&lang=js"
import style0 from "./Form_jtbttjb.vue?vue&type=style&index=0&id=55a907fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports